import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useEffect, useState } from "react";
import { IoDocumentTextSharp } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import WpDynamicTable from "../../Components/WhatsappTable/WpDynamicTable";
import {
  DeleteRegistration,
  fetchRegistration,
  UpdateRegistration,
} from "../../Redux/WhatsappSlice/ExeRegistration";
import { SendClientKeyEmail } from "../../Redux/WhatsappSlice/WhatsAppRegistration";
import { fetchProjects } from "../../Redux/WhatsappSlice/Project";
import Loader from "../../Components/Loader/Loader";
import * as XLSX from "xlsx";

const View_Registration = () => {
  // const formatDate = (date) => {
  //   if (!date) return "";
  //   const d = new Date(date);
  //   const year = d.getFullYear();
  //   const month = String(d.getMonth() + 1).padStart(2, "0");
  //   const day = String(d.getDate()).padStart(2, "0");
  //   const hours = String(d.getHours()).padStart(2, "0");
  //   const minutes = String(d.getMinutes()).padStart(2, "0");
  //   return `${year}-${month}-${day} ${hours}:${minutes}`;
  // };

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear(); // Get the full 4-digit year
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  const colorStyles = {
    red: {
      selected: "bg-red-500 text-white border-red-600",
      unselected: "bg-red-100 text-red-800 border-red-300",
    },
    yellow: {
      selected: "bg-yellow-500 text-white border-yellow-600",
      unselected: "bg-yellow-100 text-yellow-800 border-yellow-300",
    },
    green: {
      selected: "bg-green-500 text-white border-green-600",
      unselected: "bg-green-100 text-green-800 border-green-300",
    },
    blue: {
      selected: "bg-blue-500 text-white border-blue-600",
      unselected: "bg-blue-100 text-blue-800 border-blue-300",
    },
  };

  const dispatch = useDispatch();

  const { RegistrationList, RegistrationLoading } = useSelector((state) => state.ExeRegistration);
  const { ProjectData } = useSelector((state) => state.Project);

  const [filteredRows, setFilteredRows] = useState([]);
  const [colorFilter, setColorFilter] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    WhaClientName: "",
    AdminName: "",
    Project: [],
    StaticIP: "",
    Connection: "",
    PhysicalAddress: "",
    RegisterStartDate: "",
    RegisterEndDate: "",
  });

  const [selectedRowId, setSelectedRowId] = useState(null);

  useEffect(() => {
    dispatch(fetchRegistration());
    dispatch(fetchProjects());
  }, [dispatch]);

  // Helper functions
  const calculateTotalDays = (startDate, endDate) => {
    if (!startDate || !endDate) return 0;
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (isNaN(start) || isNaN(end)) return 0;
    const diff = end - start;
    const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
    return days < 0 ? 0 : days; // Never negative
  };

  const calculateDaysLeft = (endDate) => {
    if (!endDate) return 0;
    const today = new Date();
    const end = new Date(endDate);
    if (isNaN(end)) return 0;
    const diff = end - today;
    const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
    return days < 0 ? 0 : days; // Never go below 0
  };

  const exportToExcel = () => {
    if (!filteredRows || filteredRows.length === 0) {
      toast.warning("No registration data to export!");
      return;
    }

    const exportData = filteredRows.map((row, index) => {
      return {
        No: index + 1,
        "Client Name": row.WhaClientName || "-",
        "Admin Name": row.AdminID || "-",
        "Project Name": row.Project || "-",
        Connection: row.Connection || "-",
        "Physical Address": row.PhysicalAddress || "-",
        "Static IP": row.StaticIP || "-",
        "Register Start Date": row.RegisterStartDate || "-",
        "Register End Date": row.RegisterEndDate || "-",
        "Total Days": row.TotalDays || "-",
        "Days Left": row.DaysLeft || "-",
        "Client Key": row.ClientKey || "-",
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Auto column widths
    worksheet["!cols"] = Object.keys(exportData[0] || {}).map((key) => {
      const maxLen = Math.max(
        key.length,
        ...exportData.slice(0, 50).map((r) => String(r[key] || "").length)
      );
      return { wch: Math.min(Math.max(maxLen + 3, 10), 45) };
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Registration Report");

    const currentDate = new Date().toISOString().split("T")[0];
    XLSX.writeFile(workbook, `Whatsapp_Registration_${currentDate}.xlsx`);
    toast.success("Registration Report exported successfully!");
  };

  const handleColorFilterClick = (filterType) => {
    setColorFilter(filterType === colorFilter ? null : filterType);
  };

  const handleDelete = async (row) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete version ${row.Version}?`
    );
    if (!isConfirmed) return;

    try {
      await dispatch(DeleteRegistration({ id: row.MainId })).unwrap();
      toast.success("Version deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
      dispatch(fetchRegistration()); // refresh list
    } catch (error) {
      toast.error(`Failed to delete version: ${error}`, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const handleEditClick = (row) => {
    // Use the original data to avoid formatting issues
    const originalRowData = RegistrationList.find(
      (item) => item._id === row.MainId
    );

    if (!originalRowData) {
      return;
    }

    // Set the form data, extracting only the date portion for the date inputs
    setFormData({
      WhaClientName: originalRowData.ClientID?.WhaClientName || "",
      AdminName: originalRowData.AdminID?.Name || "",
      Project: originalRowData.ProjectID?.map((p) => p._id) || [],
      Connection: originalRowData.Connection || "",
      PhysicalAddress: originalRowData?.PhysicalAddress || "",
      StaticIP: originalRowData?.StaticIP || "",
      RegisterStartDate: originalRowData.RegisterStartDate
        ? new Date(originalRowData.RegisterStartDate)
          .toISOString()
          .split("T")[0]
        : "",
      RegisterEndDate: originalRowData.RegisterEndDate
        ? new Date(originalRowData.RegisterEndDate).toISOString().split("T")[0]
        : "",
    });

    setSelectedRowId(row.MainId);
    setShowModal(true);
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        ...formData,
        ProjectID: formData.Project,
        RegisterStartDate: new Date(formData.RegisterStartDate),
        RegisterEndDate: new Date(formData.RegisterEndDate),
      };
      await dispatch(
        UpdateRegistration({
          selectedRegistration: { _id: selectedRowId },
          payload,
        })
      ).unwrap();
      toast.success("Updated successfully");
      setShowModal(false);
      dispatch(fetchRegistration());
    } catch (err) {
      toast.error("Update failed");
    }
  };

  const handleSendMail = async (row) => {
    try {
      const clientId = row.originalData?.ClientID?._id;
      if (!clientId) {
        toast.error("Client ID not found for this record.");
        return;
      }
      const toastId = toast.loading("Sending email...");
      await dispatch(SendClientKeyEmail(clientId)).unwrap();
      toast.update(toastId, { render: "Email sent successfully!", type: "success", isLoading: false, autoClose: 2000 });
    } catch (error) {
      toast.error(`Failed to send email: ${error}`);
    }
  };

  // Apply filters whenever RegistrationList or filters change
  useEffect(() => {
    if (!RegistrationList) return;

    let filtered = RegistrationList.map((el, index) => {
      const totalDays = calculateTotalDays(
        el?.RegisterStartDate,
        el?.RegisterEndDate
      );
      const daysLeft = calculateDaysLeft(el?.RegisterEndDate);

      return {
        id: index + 1,
        MainId: el._id,
        WhaClientName: el?.ClientID?.WhaClientName || "-",
        Project: el?.ProjectID?.map((p) => p?.project_name).join(", ") || "-",
        Connection: el?.Connection,
        AdminID: el?.AdminID?.Name || "-",
        PhysicalAddress: el?.PhysicalAddress || "-",
        StaticIP: el?.StaticIP || "-",
        RegisterStartDate: formatDisplayDate(el?.RegisterStartDate) || "-",
        RegisterEndDate: formatDisplayDate(el?.RegisterEndDate) || "-",
        ClientKey: el?.ClientID?.ClientKey || "-",
        TotalDays: isNaN(totalDays) ? "N/A" : `${totalDays} days`,
        DaysLeft: isNaN(daysLeft) ? "N/A" : `${daysLeft} days`,
        daysLeftValue: daysLeft, // Store the numeric value for filtering
        originalData: el,
      };
    });

    // Apply color filter
    if (colorFilter) {
      filtered = filtered.filter((row) => {
        const daysLeft = row.daysLeftValue;
        if (colorFilter === "expired") return daysLeft <= 0;
        if (colorFilter === "expiring_soon")
          return daysLeft > 0 && daysLeft <= 10;
        if (colorFilter === "active") return daysLeft > 10;
        return true;
      });
    }

    setFilteredRows(filtered);
  }, [RegistrationList, colorFilter]);

  const projectMap =
    ProjectData?.reduce((acc, p) => {
      acc[p._id] = p.project_name;
      return acc;
    }, {}) || {};

  const columns = [
    { field: "id", headerName: "No", minWidth: "50px" },
    { field: "WhaClientName", headerName: "Client Name", minWidth: "200px", wrap: true },
    { field: "AdminID", headerName: "Admin Name", minWidth: "150px" },
    { field: "Project", headerName: "Project Name", minWidth: "200px", wrap: true },
    { field: "Connection", headerName: "Connection", minWidth: "80px" },
    { field: "PhysicalAddress", headerName: "Physical Address", minWidth: "250px", wrap: true },
    { field: "StaticIP", headerName: "Static IP", minWidth: "120px" },
    { field: "RegisterStartDate", headerName: "Register Start Date", minWidth: "150px" },
    { field: "RegisterEndDate", headerName: "Register End Date", minWidth: "150px" },
    { field: "TotalDays", headerName: "Total Days", minWidth: "100px" },
    { field: "ClientKey", headerName: "Client Key", minWidth: "200px", wrap: true },

    {
      field: "DaysLeft",
      headerName: "Days Left",
      minWidth: "100px",
      cellClassName: (params) => {
        const daysLeft = params.row.daysLeftValue;
        if (daysLeft <= 0) return "expired-row";
        if (daysLeft <= 10) return "expiring-soon-row";
        return "";
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: "300px",
      renderCell: (params) => (
        <div className="flex space-x-2">
          <button
            className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 whitespace-nowrap"
            onClick={() => handleSendMail(params.row)}
          >
            Send Mail
          </button>
          <button
            className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 whitespace-nowrap"
            onClick={() => handleEditClick(params.row)}
          >
            Update
          </button>
          <button
            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 whitespace-nowrap"
            onClick={() => handleDelete(params.row)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];


  if (!RegistrationList || !ProjectData || RegistrationLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            View Registration
          </h3>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap items-center justify-center md:justify-between gap-2 mb-4 p-2 bg-white rounded-md shadow-md mt-3">
          <div className="flex flex-wrap justify-center md:justify-start gap-2">
            {[
              {
                label: "Expired (0 or negative days left)",
                value: "expired",
                color: "red",
              },
              {
                label: "Expiring Soon (1–10 days left)",
                value: "expiring_soon",
                color: "yellow",
              },
              {
                label: "Active (more than 10 days left)",
                value: "active",
                color: "green",
              },
              { label: "Show All", value: null, color: "blue" },
            ].map(({ label, value, color }) => {
              const isSelected =
                colorFilter === value || (!value && colorFilter === null);
              const styleSet =
                colorStyles[color][isSelected ? "selected" : "unselected"];
              // const ringColor = isSelected ? `ring-1 ring-${color}-300` : "";

              return (
                <button
                  key={value ?? "all"}
                  onClick={() =>
                    value ? handleColorFilterClick(value) : setColorFilter(null)
                  }
                  className={`relative flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium border ${styleSet} hover:shadow-md whitespace-nowrap transition duration-150 ease-in-out`}
                >
                  {label}
                </button>
              );
            })}
          </div>

          {/* Export Button */}
          <div className="flex justify-center md:justify-end">
            <button
              onClick={exportToExcel}
              className="flex items-center justify-center gap-2 px-2 py-3 bg-green-600 text-white text-sm font-semibold rounded-md hover:bg-green-700 w-[160px]"
            >
              <IoDocumentTextSharp size={18} className="me-1" />
              Export to Excel
            </button>
          </div>
        </div>

        <div className="rounded-lg overflow-x-auto mt-5">
          <WpDynamicTable
            columns={columns}
            rows={filteredRows}
            height="700px"
            rowsPerPage={10}
          />
        </div>

        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-2">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-2xl  mx-auto h-[90vh] md:h-auto overflow-y-auto">
              <h2 className="text-lg font-semibold mb-4 text-center">
                Update Registration
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Client Name */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Client Name
                  </label>
                  <input
                    type="text"
                    value={formData.WhaClientName}
                    readOnly
                    className="w-full border border-gray-300 rounded px-3 py-2"
                  />
                </div>

                {/* Admin Name */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Admin Name
                  </label>
                  <input
                    type="text"
                    value={formData.AdminName}
                    readOnly
                    className="w-full border border-gray-300 rounded px-3 py-2"
                  />
                </div>

                {/* Project Name */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Project Name
                  </label>
                  <FormControl fullWidth>
                    <InputLabel id="project-select-label">
                      Project Name
                    </InputLabel>
                    <Select
                      labelId="project-select-label"
                      id="ProjectID"
                      multiple
                      value={formData.Project}
                      onChange={(event) =>
                        setFormData((prev) => ({
                          ...prev,
                          Project: event.target.value,
                        }))
                      }
                      input={<OutlinedInput label="Project Name" />}
                      renderValue={(selected) =>
                        selected.map((id) => projectMap[id] || id).join(", ")
                      }
                      MenuProps={{
                        PaperProps: { style: { maxHeight: 300, marginTop: 8 } },
                      }}
                    >
                      {[...(ProjectData || [])]
                        .sort((a, b) => (a.project_name || "").localeCompare(b.project_name || ""))
                        .map((project) => (
                          <MenuItem key={project._id} value={project._id}>
                            <Checkbox
                              checked={formData.Project.includes(project._id)}
                            />
                            <ListItemText primary={project.project_name} />
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>

                {/* Connection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Connection
                  </label>
                  <input
                    type="number"
                    value={formData.Connection}
                    onChange={(e) =>
                      setFormData({ ...formData, Connection: e.target.value })
                    }
                    className="w-full border border-gray-300 rounded px-3 py-2"
                  />
                </div>

                {/* Physical Address */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Physical Address
                  </label>
                  <input
                    type="text"
                    value={formData.PhysicalAddress}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        PhysicalAddress: e.target.value,
                      })
                    }
                    className="w-full border border-gray-300 rounded px-3 py-2"
                  />
                </div>

                {/* Static IP */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Static IP
                  </label>
                  <input
                    type="text"
                    value={formData.StaticIP}
                    onChange={(e) =>
                      setFormData({ ...formData, StaticIP: e.target.value })
                    }
                    className="w-full border border-gray-300 rounded px-3 py-2"
                  />
                </div>

                {/* Register Start Date */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Register Start Date
                  </label>
                  <input
                    type="date"
                    value={formData.RegisterStartDate?.split(" ")[0]}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        RegisterStartDate: e.target.value,
                      })
                    }
                    className="w-full border border-gray-300 rounded px-3 py-2"
                  />
                </div>

                {/* Register End Date */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Register End Date
                  </label>
                  <input
                    type="date"
                    value={formData.RegisterEndDate?.split(" ")[0]}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        RegisterEndDate: e.target.value,
                      })
                    }
                    className="w-full border border-gray-300 rounded px-3 py-2"
                  />
                </div>
              </div>

              {/* Buttons */}
              <div className="flex flex-col md:flex-row justify-end items-stretch md:items-center mt-6 gap-3">
                <button
                  onClick={() => setShowModal(false)}
                  className="bg-gray-500 text-white px-4 py-2 rounded w-full md:w-auto"
                >
                  Cancel
                </button>
                <button
                  onClick={handleUpdate}
                  className="bg-green-600 text-white px-4 py-2 rounded w-full md:w-auto"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default View_Registration;
